// store.ts
import {InjectionKey} from 'vue';
import {createLogger, createStore, Store, useStore as baseUseStore} from 'vuex';
import {categoryModule, CategoryStateInterface} from './modules/category';
import {pageModule, PageStateInterface} from './modules/page';
import {openDataModule, OpenDataStateInterface} from './modules/open-data';
import {configModule, ConfigStateInterface} from './modules/config';

export interface State {
    category: CategoryStateInterface,
    page: PageStateInterface,
    openData: OpenDataStateInterface,
    config: ConfigStateInterface,
}

export const key: InjectionKey<Store<State>> = Symbol()

const debug = process.env.NODE_ENV !== 'production'


export const store = createStore({
    modules: {
        category: categoryModule,
        page: pageModule,
        openData: openDataModule,
        config: configModule,
    },
    plugins: debug ? [createLogger()] : []
})

// define your own `useStore` composition function
export function useStore () {
    return baseUseStore(key);
}
